import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import VueJWT from "vuejs-jwt";
import YandexMetrika from "./plugins/yandex-metrika";
import { VueMaskDirective } from "v-mask";
import VueMeta from 'vue-meta'
import store from "./store";

Vue.config.productionTip = false;
Vue.use(require("vue-cookies"));
Vue.use(YandexMetrika);
Vue.use(VueJWT);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: false
})
Vue.use(store);
Vue.directive("mask", VueMaskDirective);
new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
